import { ExceptionOutlined } from "@ant-design/icons"
import { EUnitStatus } from "./types"
import { useState } from "react"
import Dialog from "@/libs/dialog"
import { getUnitStatus, getUnitStatusClassName } from "./utils"
import classNames from "classnames"
import { Tooltip } from "antd"

interface UnitMessageProps {
  unitSim: any
  className?: string
}

export const UnitMessageDialog = (props: UnitMessageProps) => {
  const {unitSim, className} = props
  const [show, setShow] = useState(false)
  const status = getUnitStatus(unitSim)
  const statusClassName = getUnitStatusClassName(status)
  if (!unitSim) return;

  const showTrigger = [EUnitStatus.Warning, EUnitStatus.Error].includes(status)

  if (!showTrigger) {
    return;
  }

  return <>
    <Tooltip placement="right" title={unitSim?.message}>
      <span className={classNames(statusClassName, className)} style={{cursor: 'pointer'}} onClick={() => setShow(true)}><ExceptionOutlined /></span>
    </Tooltip>
    {show && unitSim?.msgDetail && <Dialog title="Error Detail" visible={true} footer={null} onClose={() => setShow(false)}>
      <pre>
        {unitSim?.msgDetail}
      </pre>
    </Dialog>}
  </>
}